import {breakpoints} from '@smart/web-components';
import {useEffect, useState} from 'react';

export const useIsMobile = (): boolean | undefined => {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setIsMobile(window.innerWidth < breakpoints.l);
  }, []);

  return isMobile;
};
